<template>
<div>
    <h1 class="subtitle">Registrar Caja</h1>
    <div class="nj-card nj-cols">
        <div>
            <div class="nj-cols form c2">
                <div>
                    <b-field label="Titulo" custom-class="is-small">
                        <b-input v-model="form.caj_titulo" size="is-small"></b-input>
                    </b-field>
                    <b-field label="Descripcion" custom-class="is-small">
                        <b-input v-model="form.caj_descripcion" size="is-small" maxlength="400" type="textarea"></b-input>
                    </b-field>
                </div>
                <div>
                    <b-field label="Centro de Costo" custom-class="is-small">
                        <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="cec_descripcion" :data="centros_costo_filtered" @select="setCentroCosto"
                            v-model="cec_descripcion_text" :disabled="activarEditar">
                            <template slot="empty">No results found</template>
                            <template slot-scope="props">{{ props.option.cec_codigo }} {{ props.option.cec_descripcion }}</template>
                        </b-autocomplete>
                    </b-field>
                    <div class="nj-cols form c3">
                        <b-field label="Tipo Caja" custom-class="is-small">
                            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="tca_descripcion" :data="tipo_caja_filtered" @select="setTipoCaja"
                                v-model="tca_descripcion_text">
                                <template slot="empty">No results found</template>
                                <template slot-scope="props">{{ props.option.tca_descripcion }}</template>
                            </b-autocomplete>
                        </b-field>
                        <b-field label="Monto" custom-class="is-small">
                            <b-input v-model="form.caj_monto" size="is-small"></b-input>
                        </b-field>
                        <b-field label="Moneda" custom-class="is-small">
                            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="mon_descripcion" :data="monedas" @select="setMoneda" v-model="mon_descripcion_text">
                                <template slot="empty">No results found</template>
                                <template slot-scope="props">{{ props.option.mon_descripcion }}</template>
                            </b-autocomplete>
                        </b-field>
                        <b-field label="Solicitante" custom-class="is-small">
                            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="usu_nombre" :data="solicitante_filtered" @select="setSolicitante"
                                @input="setSolicitantePorDefecto"
                                v-model="solicitante_text">
                                <template slot="empty">No results found</template>
                                <template slot-scope="props">{{ props.option.usu_nombre }}</template>
                            </b-autocomplete>
                        </b-field>
                        <b-field label="Gerente" custom-class="is-small">
                            <b-autocomplete icon="magnify" clearable size="is-small" :open-on-focus="true" field="usu_nombre" :data="gerente_filtered" @select="setGerente" v-model="gerente_text">
                                <template slot="empty">No results found</template>
                                <template slot-scope="props">{{ props.option.usu_nombre }}</template>
                            </b-autocomplete>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
        <Buttons line>
            <button class="nj-button c-green" v-if="activarRegistrar" @click="registrar()"><i class="mdi mdi-content-save"></i>Registrar caja</button>
            <button class="nj-button c-green" v-if="activarEditar" @click="editar()"><i class="mdi mdi-content-save"></i>Guardar Cambios</button>
            <button class="nj-button" @click="cerrar()"><i class="mdi mdi-keyboard-backspace"></i>Regresar</button>
        </Buttons>
    </div>
</div>
</template>
<script>
import { mapActions } from "vuex"
import { estados } from "../../constants"
import Toast from "../../util/toast"
import { UsuarioService, CajaService, AppService, ResponseStatus } from "../../services"
import { Buttons } from "../components"

export default {
    name: "RegistrarCaja",
    components: {
        Buttons,
    },
    data() {
        return {
            centros_costo: [],
            tipos_caja: [],
            monedas: [],
            gerentes: [],
            usuarios: [],
            caj_id: this.$route.params.id,
            cec_descripcion_text: "",
            tca_descripcion_text: "",
            mon_descripcion_text: "",
            gerente_text: "",
            solicitante_text: "",
            form: {
                mon_id: null,
                cec_id: null,
                tca_id: null,
                caj_descripcion: null,
                caj_monto: null,
                usu_gerente: null,
                usu_solicitante: null,
            },
        }
    },
    computed: {
        centros_costo_filtered() {
            return this.centros_costo
                ? this.centros_costo.filter((item) => {
                    let text1 = (item.cec_codigo + item.cec_descripcion).replace(/[\s.]/g, "").toLowerCase()
                    let text2 = this.cec_descripcion_text.replace(/[\s.]/g, "").toLowerCase()
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
        tipo_caja_filtered() {
            return this.tipos_caja
                ? this.tipos_caja.filter((item) => {
                    let text1 = item.tca_descripcion.toLowerCase().replace(/[\s.]/g, "")
                    let text2 = this.tca_descripcion_text.toLowerCase().replace(/[\s.]/g, "")
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
        gerente_filtered() {
            return this.gerentes
                ? this.gerentes.filter((item) => {
                    let text1 = item.usu_nombre.toLowerCase().replace(/[\s.]/g, "")
                    let text2 = this.gerente_text.toLowerCase().replace(/[\s.]/g, "")
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
        solicitante_filtered() {
            return this.usuarios
                ? this.usuarios.filter((item) => {
                    let text1 = item.usu_nombre.toLowerCase().replace(/[\s.]/g, "")
                    let text2 = this.solicitante_text.toLowerCase().replace(/[\s.]/g, "")
                    return text1.indexOf(text2) >= 0
                })
                : []
        },
        activarRegistrar() {
            if (this.caj_id == null) return true
            return false
        },
        activarEditar() {
            if (this.caj_id != null) {
                if (this.form.est_id == estados.CAJA_REGISTRADA.id) return true
                if (this.form.est_id == estados.CAJA_DESAPROBADA.id) return true
            }
            return false
        }
    },
    methods: {
        ...mapActions("AppStore", ["_setMessage"]),
        setCentroCosto(option) {
            this.form.cec_id = option ? option.cec_id : null
        },
        setTipoCaja(option) {
            this.form.tca_id = option ? option.tca_id : null
        },
        setMoneda(option) {
            this.form.mon_id = option ? option.mon_id : null
        },
        setGerente(option) {
            this.form.usu_gerente = option ? option.usu_id : null
        },
        setSolicitante(option) {
            this.form.usu_solicitante = option ? option.usu_id : null
        },
        setSolicitantePorDefecto(option) {
            this.form.usu_solicitante = option ? UsuarioService.getUsuario().usu_id : null
        },
        registrar() {
            const caja = {
                mon_id: this.form.mon_id,
                cec_id: this.form.cec_id,
                tca_id: this.form.tca_id,
                caj_titulo: this.form.caj_titulo,
                caj_descripcion: this.form.caj_descripcion,
                caj_monto: parseFloat(this.form.caj_monto),
                usu_gerente: this.form.usu_gerente,
                usu_solicitante: this.form.usu_solicitante,
            }
            CajaService
                .registrar(caja)
                .then(
                    response => {
                        this._setMessage(response.message)
                        this.$router.push("/caja")
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error`, error)
                    }
                )
        },
        editar() {
            const caja = {
                caj_id: this.caj_id,
                mon_id: this.form.mon_id,
                cec_id: this.form.cec_id,
                tca_id: this.form.tca_id,
                caj_titulo: this.form.caj_titulo,
                caj_descripcion: this.form.caj_descripcion,
                caj_monto: parseFloat(this.form.caj_monto),
                usu_gerente: this.form.usu_gerente,
                usu_solicitante: this.form.usu_solicitante,
            }
            CajaService
                .editar(caja).then(
                    response => {
                        this._setMessage(response.message)
                        this.$router.push("/caja")
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error`, error)
                    }
                )
        },
        cerrar() {
            this.$router.push("/caja")
        },
    },
    mounted() {
        AppService
            .getData(["centros_costo", "gerentes", "usuarios", "tipos_caja", "monedas"])
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.centros_costo = response.data.centros_costo
                    this.tipos_caja = response.data.tipos_caja
                    this.monedas = response.data.monedas
                    this.gerentes = response.data.gerentes
                    this.usuarios = response.data.usuarios
                    if (this.caj_id != null) {
                        CajaService
                            .obtener({
                                caja: {
                                    caj_id: this.caj_id
                                },
                                usuario: UsuarioService.getUsuario()
                            }).then(
                                response => {
                                    this.form = response.data
                                    this.cec_descripcion_text = this.form.cec_descripcion
                                    this.tca_descripcion_text = this.form.tca_descripcion
                                    this.mon_descripcion_text = this.form.mon_descripcion
                                    this.gerente_text = this.form.usu_nombre_gerente
                                    this.solicitante_text = this.form.usu_nombre_solicitante
                                },
                                error => {
                                    Toast.error(error)
                                    console.error(`error`, error)
                                }
                            )
                    } else {
                        this.solicitante_text = UsuarioService.getUsuario().usu_nombre
                    }
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>
<style scoped></style>